export const LOCAL_STORAGE_KEYS = {
  LOGIN_DATA: "loginData",
  TOKEN: "token",
};
export const DOC_TYPE = {
  RESUME: "RSME",
  COVER_LETTER: "CVLT",
};
export const skuSubCategory = {
  LIMITED_CATEGORY: "MSMBROW",
  FULL_ACCESS_CATEGORY: "MSBRW95",
  ANNUAL_CATEGORY: "YSMBROW",
  EFLOW_LIMITED_CATEGORY: "LM50395",
  EFLOW_FULL_ACCESS_CATEGORY: "DOWN000",
  EFLOW_ANNUAL_CATEGORY: "SUSER00",
};
// export const SECTION_CODE = {
// 	NONE: 0,
// 	HEAD: 10,
// 	OPNR: 15,
// 	SUMM: 20,
// 	BODY: 25,
// 	EDUC: 30,
// 	GAPS: 35,
// 	EXPR: 40,
// 	CLSR: 45,
// 	ACCM: 50,
// 	SKLS: 60,
// 	CSTM: 70,
// 	LANG: 80,
// 	OTHR: 90,
// };

// export const SECTION_TYPE = {
//   NONE: "NONE",
//   HEAD: "HEAD",
//   SUMM: "SUMM",
//   EDUC: "EDUC",
//   EXPR: "EXPR",
//   ACCM: "ACCM",
//   SKLS: "SKLS",
//   LANG: "LANG",
//   CSTM: "CSTM",
//   OTHR: "OTHR",
//   OPNR: "OPNR",
//   BODY: "BODY",
//   GAPS: "GAPS",
//   CLSR: "CLSR",
//   CVLTS: "CVLTS",
// };

// export const SECTION_ORDER = {
// 	// NONE: 0,
// 	// HEAD: 1,
// 	// SUMM: 2,
// 	// EDUC: 3,
// 	// EXPR: 4,
// 	// ACCM: 5,
// 	// SKLS: 6,
// 	// LANG: 7,
// 	// CSTM: 8,
// 	// OTHR: 9,
// 	HEAD: 0,
// 	SUMM: 1,
// 	EXPR: 2,
// 	EDUC: 3,
// 	SKLS: 4,
// 	ACCM: 5,
// 	LANG: 6,
// 	CSTM: 7,
// 	OTHR: 8,
// 	OPNR: 10,
// 	BODY: 11,
// 	GAPS: 12,
// 	CLSR: 13,
// 	DSRDCPNY: 1, // SUMM:1 is used in resume build and DSRDCPNY:1 used in cover-letter. that's not conflict
// 	SIGN: 50,
// 	NONE: 100,
// };

// export const DOC_STAGE = {
// 	NONE: "NONE",
// 	HEAD: "HEAD",
// 	SUMM: "SUMM",
// 	EDUC: "EDUC",
// 	EXPR: "EXPR",
// 	ACCM: "ACCM",
// 	SKLS: "SKLS",
// 	CSTM: "CSTM",
// 	OTHR: "OTHR",
// 	OPNR: "OPNR",
// 	BODY: "BODY",
// 	GAPS: "GAPS",
// 	CLSR: "CLSR",
// };

export const APP_NAVIGATION = {
  NONE: "NONE",
  HOME: "HOME",
  REVW: "REVW", // Review
  SINI: "SINI", // Sing In
  SINU: "SINU", // Sing Up
  SIOT: "SIOT", // Sing Out
  CONF: "CONF",
  PLAN: "PLAN", // plans
  STNG: "STNG", //Settings
  ADLG: "ADLG", //Admin Login
  CASU: "CASU", //Cancel Subscription
  CHPG: "CHPG", //Checkout Page
  PRVY: "PRVY", //Privacy policy
  CNTC: "CNTC", //Contact us
  TUSE: "TUSE", //Terms of use
  RHOM: "RHOM", //Root home
  EFLOW: "EFLOW", //Eflow
  DASH: "DASH", //Dashboard
  FAQ: "FAQ", //FAQ
  PSCNTC: "PSCNTC", //pdf contact
};

// export const RatingValues = {
// 	Basic: 1,
// 	Proficient: 2,
// 	Conversational: 3,
// 	Fluent: 4,
// 	"Native speaker": 5,
// };
// export const getRatingWidth = (rating) => {
// 	const currentValue = rating;
// 	if (!currentValue) return 0;
// 	return `${(currentValue * 100) / 5}%`;
// };
// export const GetRatingCircle = ({ rating }) => {
// 	const currentValue = rating;
// 	if (!currentValue) return <></>;
// 	const filled = Array.from({ length: currentValue }, (_, i) => i + 1);
// 	const empty = Array.from({ length: 5 - currentValue }, (_, i) => i + 1);
// 	return (
// 		<>
// 			{filled.map((item) => (
// 				<span className="active" key={"filled" + item} />
// 			))}
// 			{empty.map((item) => (
// 				<span key={"empty" + item} />
// 			))}
// 		</>
// 	);
// };

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
export const DEFAULT_USER_GUID = "a0000000-0000-0000-0000-00000000000a";
export const WELCOME_DOCUMENT_PATH_DIRECTORY = "masterdocuments";
export const WELCOME_DOCUMENT_NAME = "##_WELCOME_GUIDEBOOK.pdf";
export const FROM_EMAIL_NAME = "##Simpli";
export const WELCOME_EMAIL_TEXT = "Welcome to ##!";

export const AFFILIATE_STORAGE_NAME = "account";
export const AFFILIATE_KEYWORD_NAME = "keyword";
export const AFFILIATE_SOURCE_NAME = "regi";
export const AFFILIATE_SOURCE_VALUE = "intro";

export const ABTESTID_SUMMARIZER = "bb69a6c3-99b9-4ad6-a4f5-5ee93b142A38";
export const ABTEST_SUMMARIZER_COOKIE = "sumzhsabval";

export const ABTESTID_TRANSLATIONOCR = "27A79667-30B7-46BD-A2FD-7A83AFB79FB5";
export const ABTESTID_TRANSLATIONOCR_PROCESSIGNG = "FC6C648F-1EF2-4A1B-85C9-B0208A1DDE1C";
export const ABTEST_TRANSLATIONOCR_COOKIE = "transocrvarientabval";

export const FOOTER_LINKS = {
  CONTACT_US: "contact-us",
  PRIVACY_POLICY: "privacy-policy",
  TERMS_CONDITIONS: "terms-and-conditions",
};
export const SUPPORT_LINKS = {
  SUPPORT: "support",
};

export const SKILL_SELECTION_LIMIT = 3;

export const ImageType = {
  SIGNATURE: 0,
  PROFILE: 1,
};

export const EVENT_CATEGORY = {
  PAYMENT: "payment",
};
export const EVENT_SUBCATEGORY = {
  PAYMENT_FAILED: "payment_failed",
};
export const EVENT_TOPIC = {
  PAYMENT: "payment",
};
export const NewPricingFlowQueryString = {
  SKUCATEGORY: "skuc",
  CURRENCY: "currency",
  SKUGUID: "skuid",
  USERS: "users",
};

export const DomainName = {
  PDFSIMPLI: "pdfsimpli",
  RESUMEBUILD: "resumebuild",
  LEGALSIMPLI: "legalsimpli",
  SIGNSIMPLI: "signsimpli",
  WORKSIMPLI: "worksimpli",
};
export const supportEmail = {
  PDFSIMPLI: "support@pdfsimpli.com",
  RESUMEBUILD: "support@resumebuild.com",
  LEGALSIMPLI: "support@legalsimpli.com",
  SIGNSIMPLI: "support@signsimpli.com",
};
export const BasePortalCD = {
  PS: "PS",
  WSRB: "WSRB",
  SS: "SS",
  LSEN: "LSEN",
  WKSM: "WKSM",
};

export const PORTAL_CD_LOCALE = {
  WSRB: "WSRB",
  WSRBES: "WSRBES",
  WSRBIT: "WSRBIT",
  WSRBPT: "WSRBPT",
  WSRBFR: "WSRBFR",
  WSRBAR: "WSRBAR",
};
//ToDo: This is to be changed for PS, SS, LS, WSRB (all locale)

export const emailTemplateSettingsList = [
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "en",
    TemplateName: "pdfsimpli_welcome_email",
    WelcomeEmailTemplateId: "166A1404-812D-4E6D-A9E2-01CDD4D66A1D",
    WelcomeEmailReskinTemplateId: "5C3015E9-004B-4724-A7A8-F33304D8FCF7",
  },
   {
    portal: DomainName.WORKSIMPLI,
    Locale: "en",
    TemplateName: "pdfsimpli_welcome_email",
    WelcomeEmailTemplateId: "4ef03f52-235f-4643-9ea6-029c5e6c6686",
  },
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "vi",
    TemplateName: "pdfsimpli_welcome_email_vi",
    WelcomeEmailTemplateId: "56B2B133-C7EB-4CCE-8A8B-0E14AC59BF3D",
  },
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "de",
    TemplateName: "pdfsimpli_welcome_email_de",
    WelcomeEmailTemplateId: "D60DD774-E72B-49FA-A6B3-1079F5E96C25",
  },
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "hi",
    TemplateName: "pdfsimpli_welcome_email_hi",
    WelcomeEmailTemplateId: "869EC431-AAA6-40FA-B7C8-1485814D39CF",
  },
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "tr",
    TemplateName: "pdfsimpli_welcome_email_tr",
    WelcomeEmailTemplateId: "A1C6BFB4-1BEB-44D7-8DDE-261FABF0AC21",
  },
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "zh",
    TemplateName: "pdfsimpli_welcome_email_zh",
    WelcomeEmailTemplateId: "F0797A92-9A3D-4C6A-8522-2DE757426A4B",
  },
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "it",
    TemplateName: "pdfsimpli_welcome_email_it",
    WelcomeEmailTemplateId: "AA4096D9-4203-483F-AA56-39B47E0E889F",
  },
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "ru",
    TemplateName: "pdfsimpli_welcome_email_ru",
    WelcomeEmailTemplateId: "CBDA7241-0EC6-4655-87C9-3B6A45BCECDE",
  },
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "ja",
    TemplateName: "pdfsimpli_welcome_email_ja",
    WelcomeEmailTemplateId: "D268C86F-67A2-4EC3-9988-6516961F298E",
  },
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "nl",
    TemplateName: "pdfsimpli_welcome_email_nl",
    WelcomeEmailTemplateId: "4F86FD7A-64E6-458A-B9DE-6ADA38CCD12C",
  },
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "fr",
    TemplateName: "pdfsimpli_welcome_email_fr",
    WelcomeEmailTemplateId: "C3F2EE30-ED6F-407C-ACEA-C6CFB5623FAC",
  },
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "pt",
    TemplateName: "pdfsimpli_welcome_email_pt",
    WelcomeEmailTemplateId: "4053D8E6-6D78-4516-80F4-CB61927E34FF",
  },
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "ph",
    TemplateName: "pdfsimpli_welcome_email_ph",
    WelcomeEmailTemplateId: "7EA32B31-6A53-4BBF-A197-DC570CDF6C38",
  },
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "tl",
    TemplateName: "pdfsimpli_welcome_email_ph",
    WelcomeEmailTemplateId: "7EA32B31-6A53-4BBF-A197-DC570CDF6C38",
  },
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "es",
    TemplateName: "pdfsimpli_welcome_email_es",
    WelcomeEmailTemplateId: "EC36B216-3295-4A2A-9020-E1971551DDE7",
  },
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "pl",
    TemplateName: "pdfsimpli_welcome_email_pl",
    WelcomeEmailTemplateId: "2BCBEC54-9F31-4174-A26C-F02F0192E7EB",
  },
  {
    portal: DomainName.PDFSIMPLI,
    Locale: "ar",
    TemplateName: "pdfsimpli_welcome_email_ar",
    WelcomeEmailTemplateId: "8AD49F3E-3137-4AC5-9BCE-FFB946B21FAB",
  },
  {
    portal: DomainName.SIGNSIMPLI,
    Locale: "en",
    TemplateName: "signsimpli_welcome_email",
    WelcomeEmailTemplateId: "fe18815e-1047-45a9-9976-156b08814a76",
    ForgotPasswordEmail: "",
  }, //,
  // {
  //   portal: DomainName.SIGNSIMPLI,
  //   Locale: "en",
  //   TemplateName: "signsimpli_forgot_email",
  //   WelcomeEmailTemplateId: "fe18815e-1047-45a9-9976-156b08814a76",//To be changed
  //   ForgotPasswordEmail:""
  // }
];

export const splitAliases = [
  "split",
  "dividir",
  "dividi",
  "divisé",
  "dividido",
  "teilen",
  "تقسيم",
  "splitsen",
  "分割",
  "拆分",
  "विभाजित",
  "tách",
  "разделить",
  "hating",
  "podział",
  "bölmek",
];

export const compressAliases = [
  "compress",
  "comprimir",
  "comprimi",
  "compresse",
  "ضغط",
  "komprimieren",
  "संकुचित करें",
  "圧縮",
  "comprimeren",
  "i-compress",
  "kompresuj",
  "компресс",
  "kompres",
  "nén",
  "压缩",
];
export const reSkinContainerName = {
  CONTAINER: "rebrandversion1",
};
